import { DanceManagerSubscriptionInterface } from '../../..';

export class MarketplaceSubscriptionInfoDto implements DanceManagerSubscriptionInterface{
  subscriptionPlan: string;
  subscriptionInterval: string;
}
